export const ActionTypes = {
    REGISTER_USER: "REGISTER_USER",
    LOGIN_USER: "LOGIN_USER",
    VERIFY_USER: "VERIFY_USER",
    LOGOUT_USER: "LOGOUT_USER"
}